import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import PageCover from '../page-cover';
import { TEXT_ALIGNMENT_CLASS_NAMES } from '../../constants/text-alignment';
import forDesktopOnly from '../../hoc/for-desktop-only';
import withCategoryTextAlignment from '../../hoc/with-category-text-alignment';
import styles from './page-description.scss';

const DEFAULT_HEIGHT = 200;

const getContainerStyle = (textColor = {}, isCoverVisible = true) => {
  const style = { color: textColor.color };
  if (!isCoverVisible) {
    style.display = 'none';
  }
  return style;
};

export const PageDescription = props => {
  const {
    title,
    description,
    cover,
    coverType,
    overlayColor,
    backgroundColor,
    textColor = {},
    categoryTextAlignment,
    children,
    isCoverVisible,
  } = props;

  const textAlignmentClassName = styles[TEXT_ALIGNMENT_CLASS_NAMES[categoryTextAlignment]];
  const containerClassName = classNames(styles.container, 'default-desktop-header-text-color', 'page-description', {
    [textAlignmentClassName]: textAlignmentClassName,
  });

  const NoCover = ({ children }) =>
    <div>
      {children}
    </div>;

  const CoverComponent = isCoverVisible ? PageCover : NoCover;

  return (
    <div className={containerClassName} style={getContainerStyle(textColor, isCoverVisible)}>
      <CoverComponent
        cover={cover}
        coverType={coverType}
        overlayColor={overlayColor}
        backgroundColor={backgroundColor}
        height={DEFAULT_HEIGHT}
        hasActiveState={false}
      >
        <div className={styles.wrapper}>
          <div
            className={classNames(styles.titleWrapper, 'page-description-title-font', 'page-description__title')}
            data-hook="page-description__title"
          >
            <h1 className={styles.title}>
              {title}
            </h1>
          </div>
          <div
            className={classNames(styles.descriptionWrapper, 'page-description-font')}
            data-hook="page-description__description"
          >
            <p className={styles.description}>
              {description}
            </p>
          </div>
          {children}
        </div>
      </CoverComponent>
    </div>
  );
};

PageDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cover: PropTypes.object,
  coverType: PropTypes.string,
  overlayColor: PropTypes.object,
  backgroundColor: PropTypes.object,
  textColor: PropTypes.object,
  categoryTextAlignment: PropTypes.number.isRequired,
  children: PropTypes.node,
  isCoverVisible: PropTypes.bool.isRequired,
};

PageDescription.defaultProps = {
  isCoverVisible: true,
};

export default withCategoryTextAlignment(PageDescription);

export const PageDescriptionDesktop = forDesktopOnly(withCategoryTextAlignment(PageDescription));



// WEBPACK FOOTER //
// ./app/components/page-description/page-description.js